import Phaser from 'phaser';
import { GAME_WIDTH, UI_CENTER_Y } from '../core/Config';
import { PortraitManifestEntry } from '../types/data';

export class PortraitCatalogPanel {
  private readonly container: Phaser.GameObjects.Container;
  private readonly body: Phaser.GameObjects.Text;
  private readonly preview: Phaser.GameObjects.Image;
  private items: PortraitManifestEntry[] = [];
  private index = 0;
  private visibleState = false;

  constructor(private readonly scene: Phaser.Scene) {
    const outer = scene.add.rectangle(0, 0, 560, 360, 0x0b1220, 0.98).setStrokeStyle(3, 0xf59e0b, 0.8).setOrigin(0.5);
    const inner = scene.add.rectangle(0, 0, 530, 330, 0x172033, 0.95).setStrokeStyle(2, 0x7dd3fc, 0.7).setOrigin(0.5);
    const title = scene.add.text(0, -145, '초상화 카탈로그', { fontSize: '28px', color: '#fef3c7', fontStyle: 'bold' }).setOrigin(0.5);
    this.preview = scene.add.image(-160, 18, 'npc_village').setDisplaySize(140, 180);
    this.body = scene.add.text(-34, -72, '', { fontSize: '18px', color: '#dbeafe', lineSpacing: 8, wordWrap: { width: 250 } });
    this.container = scene.add.container(GAME_WIDTH - 320, UI_CENTER_Y + 110, [outer, inner, title, this.preview, this.body]).setDepth(12120).setScrollFactor(0).setVisible(false);
  }

  setItems(items: PortraitManifestEntry[]) {
    this.items = items;
    this.index = 0;
    this.render();
  }

  toggle() { this.setVisible(!this.visibleState); }
  hide() { this.setVisible(false); }
  isVisible() { return this.visibleState; }
  setVisible(value: boolean) { this.visibleState = value; this.container.setVisible(value); if (value) this.render(); }

  move(delta: number) {
    if (!this.items.length) return;
    this.index = Phaser.Math.Wrap(this.index + delta, 0, this.items.length);
    this.render();
  }

  private render() {
    if (!this.items.length) {
      this.body.setText('portrait-manifest.json에 항목을 추가하면 여기에 바로 표시됩니다.');
      return;
    }
    const item = this.items[this.index];
    if (this.scene.textures.exists(item.key)) {
      this.preview.setTexture(item.key).setDisplaySize(item.width ?? 140, item.height ?? 180);
    }
    this.body.setText([
      `키: ${item.key}`,
      `이름: ${item.label ?? '-'}`,
      `그룹: ${item.group ?? '-'}`,
      `경로: ${item.path}`,
      '',
      `인덱스: ${this.index + 1} / ${this.items.length}`,
      '방향키 이동  Esc 닫기',
      '대화 데이터의 portraitKey로 바로 사용할 수 있습니다.',
    ]);
  }
}
